<mat-form-field class="search-bar">
  <input matInput type="text" [formControl]="search">
  <mat-icon matSuffix>search</mat-icon>
</mat-form-field>

